function normalizeFileToken(value) {
  return String(value || "")
    .trim()
    .replace(/[^A-Za-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

export function reportFileStem({
  moduleName,
  companyName,
  deviceName,
}) {
  return [
    "wirelesspress",
    normalizeFileToken(moduleName || "report"),
    normalizeFileToken(companyName || "all-companies"),
    normalizeFileToken(deviceName || "all-devices"),
    new Date().toISOString().slice(0, 10),
  ]
    .filter(Boolean)
    .join("-");
}

export function printCurrentReport({ title } = {}) {
  const originalTitle = document.title;

  if (title) document.title = title;

  try {
    window.print();
  } finally {
    window.setTimeout(() => {
      document.title = originalTitle;
    }, 250);
  }
}

function spreadsheetSafeValue(value) {
  const text =
    value === null || value === undefined
      ? ""
      : String(value);

  const leftTrimmed =
    text.replace(/^[\t\r\n ]+/, "");

  if (/^[=+\-@]/.test(leftTrimmed)) {
    return `'${text}`;
  }

  return text;
}

function csvCell(value) {
  const safe = spreadsheetSafeValue(value);
  return `"${safe.replace(/"/g, '""')}"`;
}

function downloadCsv(lines, filename) {
  const blob = new Blob(
    ["\uFEFF", lines.join("\r\n")],
    { type: "text/csv;charset=utf-8" }
  );

  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = href;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
}

export function exportVisibleRowsCsv({
  rows = [],
  columns = [],
  filename = "wirelesspress-report.csv",
}) {
  const safeRows =
    Array.isArray(rows) ? rows : [];
  const safeColumns =
    Array.isArray(columns) ? columns : [];

  const lines = [];

  if (safeColumns.length) {
    lines.push(
      safeColumns
        .map((column) =>
          csvCell(
            column.label ||
              column.key ||
              ""
          )
        )
        .join(",")
    );

    safeRows.forEach((row) => {
      lines.push(
        safeColumns
          .map((column) => {
            const value =
              typeof column.value ===
              "function"
                ? column.value(row)
                : row?.[column.key];

            return csvCell(value);
          })
          .join(",")
      );
    });
  }

  downloadCsv(lines, filename);
}
